import { videoUIDs } from '../utilities/isVideoTransferSyntax.js';
const list = (uids) => uids;
export const imageSopClassUids = list([
    '1.2.840.10008.5.1.4.1.1.1',
    '1.2.840.10008.5.1.4.1.1.1.1',
    '1.2.840.10008.5.1.4.1.1.1.1.1',
    '1.2.840.10008.5.1.4.1.1.1.2',
    '1.2.840.10008.5.1.4.1.1.1.2.1',
    '1.2.840.10008.5.1.4.1.1.1.3',
    '1.2.840.10008.5.1.4.1.1.1.3.1',
    '1.2.840.10008.5.1.4.1.1.2',
    '1.2.840.10008.5.1.4.1.1.2.1',
    '1.2.840.10008.5.1.4.1.1.2.2',
    '1.2.840.10008.5.1.4.1.1.3.1',
    '1.2.840.10008.5.1.4.1.1.4',
    '1.2.840.10008.5.1.4.1.1.4.1',
    '1.2.840.10008.5.1.4.1.1.4.3',
    '1.2.840.10008.5.1.4.1.1.4.4',
    '1.2.840.10008.5.1.4.1.1.6.1',
    '1.2.840.10008.5.1.4.1.1.6.2',
    '1.2.840.10008.5.1.4.1.1.7',
    '1.2.840.10008.5.1.4.1.1.7.1',
    '1.2.840.10008.5.1.4.1.1.7.2',
    '1.2.840.10008.5.1.4.1.1.7.3',
    '1.2.840.10008.5.1.4.1.1.7.4',
    '1.2.840.10008.5.1.4.1.1.12.1',
    '1.2.840.10008.5.1.4.1.1.12.1.1',
    '1.2.840.10008.5.1.4.1.1.12.2',
    '1.2.840.10008.5.1.4.1.1.12.2.1',
    '1.2.840.10008.5.1.4.1.1.13.1.1',
    '1.2.840.10008.5.1.4.1.1.13.1.2',
    '1.2.840.10008.5.1.4.1.1.13.1.3',
    '1.2.840.10008.5.1.4.1.1.13.1.4',
    '1.2.840.10008.5.1.4.1.1.13.1.5',
    '1.2.840.10008.5.1.4.1.1.14.1',
    '1.2.840.10008.5.1.4.1.1.14.2',
    '1.2.840.10008.5.1.4.1.1.20',
    '1.2.840.10008.5.1.4.1.1.77.1.1',
    '1.2.840.10008.5.1.4.1.1.77.1.1.1',
    '1.2.840.10008.5.1.4.1.1.77.1.2',
    '1.2.840.10008.5.1.4.1.1.77.1.2.1',
    '1.2.840.10008.5.1.4.1.1.77.1.3',
    '1.2.840.10008.5.1.4.1.1.77.1.4',
    '1.2.840.10008.5.1.4.1.1.77.1.4.1',
    '1.2.840.10008.5.1.4.1.1.77.1.5.1',
    '1.2.840.10008.5.1.4.1.1.77.1.5.2',
    '1.2.840.10008.5.1.4.1.1.77.1.5.4',
    '1.2.840.10008.5.1.4.1.1.77.1.6',
    '1.2.840.10008.5.1.4.1.1.82.1',
    '1.2.840.10008.5.1.4.1.1.128',
    '1.2.840.10008.5.1.4.1.1.128.1',
    '1.2.840.10008.5.1.4.1.1.130',
    '1.2.840.10008.5.1.4.1.1.481.1',
    '1.2.840.10008.5.1.4.1.1.481.2',
]);
export const videoSopClassUids = list([
    '1.2.840.10008.5.1.4.1.1.77.1.1.1',
    '1.2.840.10008.5.1.4.1.1.77.1.2.1',
    '1.2.840.10008.5.1.4.1.1.77.1.4.1',
]);
export const videoTransferSyntaxUids = list([...videoUIDs]);
export const longVideoSopClassUids = list([
    '1.2.840.10008.5.1.4.1.1.7',
    '1.2.840.10008.5.1.4.1.1.7.4',
]);
export const longVideoMinFrames = 90;
export const ecgSopClassUids = list([
    '1.2.840.10008.5.1.4.1.1.9.1.1',
    '1.2.840.10008.5.1.4.1.1.9.1.2',
    '1.2.840.10008.5.1.4.1.1.9.1.3',
    '1.2.840.10008.5.1.4.1.1.9.2.1',
    '1.2.840.10008.5.1.4.1.1.9.3.1',
]);
export const wholeSlideSopClassUids = list([
    '1.2.840.10008.5.1.4.1.1.77.1.6',
]);
export const segmentationSopClassUids = list([
    '1.2.840.10008.5.1.4.1.1.66.4',
    '1.2.840.10008.5.1.4.1.1.66.7',
]);
export const rtStructureSetSopClassUids = list([
    '1.2.840.10008.5.1.4.1.1.481.3',
]);
export const parametricMapSopClassUids = list([
    '1.2.840.10008.5.1.4.1.1.30',
]);
export const structuredReportSopClassUids = list([
    '1.2.840.10008.5.1.4.1.1.88.11',
    '1.2.840.10008.5.1.4.1.1.88.22',
    '1.2.840.10008.5.1.4.1.1.88.33',
    '1.2.840.10008.5.1.4.1.1.88.34',
    '1.2.840.10008.5.1.4.1.1.88.67',
]);
export const encapsulatedDocumentSopClassUids = list([
    '1.2.840.10008.5.1.4.1.1.104.1',
]);
export const bulkAnnotationSopClassUids = list([
    '1.2.840.10008.5.1.4.1.1.91.1',
]);
export const chartSopClassUids = list([]);
